import {
  Directive,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  Input,
  DoCheck,
  IterableDiffer,
  IterableDiffers,
  IterableChanges
} from '@angular/core';
import {ExgMapHeatmapLayerManagerService} from '../services';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: 'exg-map-heatmap-layer',
})
export class ExgMapHeatmapLayerDirective implements OnInit, OnChanges, OnDestroy, DoCheck {
  private static _heatmapLayerOptions: string[] = ['data', 'dissipating', 'gradient', 'maxIntensity', 'opacity', 'radius', 'options'];
  private _addedToManager = false;
  private _diff!: IterableDiffer<any>;
  @Input() data: google.maps.MVCArray<google.maps.LatLng
      | google.maps.visualization.WeightedLocation>
    | (google.maps.LatLng
    | google.maps.visualization.WeightedLocation)[] | null = null;
  @Input() dissipating = false;
  @Input() gradient: string[] | null = null;
  @Input() maxIntensity: number | null = null;
  @Input() radius: number | null = null;
  @Input() opacity = 1;

  constructor(
    private _manager: ExgMapHeatmapLayerManagerService, private _iterableDiffers: IterableDiffers
  ) {
  }

  ngOnInit(): void {
    this._manager.addHeatmapLayer(this);
    this._addedToManager = true;
    this._diff = this._iterableDiffers.find(this.data).create();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!this._addedToManager) {
      return;
    }

    this._updatePolygonOptions(changes);
  }

  ngDoCheck(): void {
    const changes: IterableChanges<any> = this._diff.diff(this.data as any) as any;
    if (changes) {
      this._manager.setData(this, this.data);
    }
  }


  private _updatePolygonOptions(changes: SimpleChanges): void {
    const options = Object.keys(changes)
      .filter(k => ExgMapHeatmapLayerDirective._heatmapLayerOptions.indexOf(k) !== -1)
      .reduce((obj: any, k: string) => {
        obj[k] = changes[k].currentValue;
        return obj;
      }, {});
    if (Object.keys(options).length > 0) {
      this._manager.setOptions(this, options);
    }
  }

  ngOnDestroy(): void {
    this._manager.deleteHeatmapLayer(this);
  }

}
